import { z } from 'zod';

/**
 * Opcjonalne pole liczbowe formularza. Puste pole trafia do RHF jako NaN
 * (`register(..., { valueAsNumber: true })`) albo jako pusty string — obu
 * `z.number().optional()` nie przepuszcza, więc sprowadzamy je do `undefined`.
 */
export const optionalPositiveNumberSchema = (
  message = 'Wartość musi być większa niż 0',
) =>
  z
    .union([z.number(), z.nan(), z.literal(''), z.null()])
    .optional()
    .transform((value) =>
      typeof value === 'number' && !Number.isNaN(value) ? value : undefined,
    )
    .pipe(z.number().positive(message).optional());
